// src/components/casting/NoticesList.jsx
import React from "react";
import { Box, Pagination } from "@mui/material";
import NoticeCard from "./NoticeCard";
import AppLoader from "../common/AppLoader";
import { useLocationLabels } from "../../hooks/useLocationLabels";

export default function NoticesList({
  notices = [],
  loading,
  page,
  totalPages,
  onPageChange,
  navigate,
  isAdmin = false,
}) {
  const {
    loading: loadingLocations,
    formatLocations,
  } = useLocationLabels();

  if (loading) {
    return <AppLoader message="Searching notices..." />;
  }

  if (!Array.isArray(notices) || notices.length === 0) {
    return null;
  }

  return (
    <>
      {notices.map((notice) => (
        <NoticeCard
          key={notice.noticeId}
          notice={notice}
          navigate={navigate}
          formatLocations={formatLocations}
          loadingLocations={loadingLocations}
          isAdmin={isAdmin}
        />
      ))}

      {totalPages > 1 && (
        <Box display="flex" justifyContent="center" mt={3}>
          <Pagination
            count={totalPages}
            page={page}
            onChange={onPageChange}
            color="primary"
          />
        </Box>
      )}
    </>
  );
}